import { useEffect, useRef, useState } from "react";

type ScrollDirection = "up" | "down" | null;

export function useScrollDirection(
	targetRef: React.RefObject<HTMLElement | null>,
	threshold = 10,
): ScrollDirection {
	const [direction, setDirection] = useState<ScrollDirection>(null);
	const lastScrollY = useRef(0);
	const idleTimer = useRef<ReturnType<typeof setTimeout> | undefined>(
		undefined,
	);

	useEffect(() => {
		const el = targetRef.current;
		if (!el) return;

		const onScroll = () => {
			const currentY = el.scrollTop;
			const diff = currentY - lastScrollY.current;

			if (Math.abs(diff) < threshold) return;

			setDirection(diff > 0 ? "down" : "up");
			lastScrollY.current = currentY;

			// Show bars again after scrolling stops
			if (idleTimer.current) clearTimeout(idleTimer.current);
			idleTimer.current = setTimeout(() => setDirection(null), 800);
		};

		el.addEventListener("scroll", onScroll, { passive: true });
		return () => {
			el.removeEventListener("scroll", onScroll);
			if (idleTimer.current) clearTimeout(idleTimer.current);
		};
	}, [targetRef, threshold]);

	return direction;
}
